import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=015de462&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"
import style0 from "./Button.vue?vue&type=style&index=0&id=015de462&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015de462",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('015de462')) {
      api.createRecord('015de462', component.options)
    } else {
      api.reload('015de462', component.options)
    }
    module.hot.accept("./Button.vue?vue&type=template&id=015de462&scoped=true", function () {
      api.rerender('015de462', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Button.vue"
export default component.exports